export const BASE_URL = "https://ali.sigisolutions.net/";
export const BASE_URL_PAYMENT = "https://ali.sigisolutions.net/";
// export const BASE_URL = "https://edit.fomino.ch:3042/";
// export const BASE_URL = "https://backend.fomino.ch:3041/";
export const WEB_URL = "http://singlevendor.sigisolutions.net/";

// export const BASE_URL = "http://192.168.1.110:3041/";
export const googleApiKey = "AIzaSyD68_vw1gGE7LVVjJ5ZShy7qWwm9Rq0CBQ";
